// Extra content pulled from astrodev.me (bilingual). Kept in a separate file
// so Home.jsx can stay readable.

export const zodiacSigns = [
  { hi: "मेष", en: "Aries", range: "21 Mar - 19 Apr", glyph: "♈" },
  { hi: "वृषभ", en: "Taurus", range: "20 Apr - 20 May", glyph: "♉" },
  { hi: "मिथुन", en: "Gemini", range: "21 May - 20 Jun", glyph: "♊" },
  { hi: "कर्क", en: "Cancer", range: "21 Jun - 22 Jul", glyph: "♋" },
  { hi: "सिंह", en: "Leo", range: "23 Jul - 22 Aug", glyph: "♌" },
  { hi: "कन्या", en: "Virgo", range: "23 Aug - 22 Sep", glyph: "♍" },
  { hi: "तुला", en: "Libra", range: "23 Sep - 22 Oct", glyph: "♎" },
  { hi: "वृश्चिक", en: "Scorpio", range: "23 Oct - 21 Nov", glyph: "♏" },
  { hi: "धनु", en: "Sagittarius", range: "22 Nov - 21 Dec", glyph: "♐" },
  { hi: "मकर", en: "Capricorn", range: "22 Dec - 19 Jan", glyph: "♑" },
  { hi: "कुंभ", en: "Aquarius", range: "20 Jan - 18 Feb", glyph: "♒" },
  { hi: "मीन", en: "Pisces", range: "19 Feb - 20 Mar", glyph: "♓" },
];

export const whyChooseCopy = {
  hi: {
    title: "गुरुजी को क्यों चुनें",
    sub: "ज्योतिष तब उत्तम होता है जब वह सटीक, नैतिक और तार्किक हो।",
    items: [
      "25+ वर्षों का व्यावसायिक ज्योतिष अनुभव",
      "के.पी. ज्योतिष एवं कस्पल इंटरलिंक थ्योरी में विशेषज्ञता",
      "जन्म समय का सटीक शुद्धीकरण (Birth Time Rectification)",
      "व्यावहारिक लाल किताब उपाय — पूर्णतः सुरक्षित",
      "कोई अंधविश्वास या अतिशयोक्ति नहीं",
      "ग्रहों के प्रभाव की स्पष्ट व्याख्या",
      "पूर्णतः गोपनीय एवं केंद्रित परामर्श",
    ],
  },
  en: {
    title: "Why Choose Guruji",
    sub: "Astrology works best when it is accurate, ethical, and logical.",
    items: [
      "25+ years of professional astrology practice",
      "Expertise in KP Astrology & Cuspal Interlink Theory",
      "Accurate birth time rectification",
      "Practical Lal Kitab remedies (non-harmful)",
      "No superstition or exaggerated claims",
      "Clear explanation of planetary influences",
      "Confidential & focused consultations",
    ],
  },
};

export const problemAreasCopy = {
  hi: {
    title: "परामर्श के प्रमुख क्षेत्र",
    sub: "आमतौर पर ग्राहक इन विषयों पर परामर्श लेते हैं।",
    items: [
      "करियर उलझन, नौकरी परिवर्तन, व्यवसायिक निर्णय",
      "विवाह में विलंब एवं संबंधों में तनाव",
      "मेलापक एवं वैवाहिक सामंजस्य",
      "संतान एवं प्रजनन से जुड़ी चिंताएँ",
      "आर्थिक अस्थिरता एवं बार-बार हानि",
      "संपत्ति विवाद, पारिवारिक तनाव और कानूनी दबाव",
      "जीवन दिशा एवं निर्णय का उचित समय",
    ],
  },
  en: {
    title: "Problem-Solving Areas of Consultation",
    sub: "Clients commonly seek consultation for these areas.",
    items: [
      "Career confusion, job change, business decisions",
      "Marriage delays and relationship disturbances",
      "Compatibility and marital harmony",
      "Childbirth & progeny-related concerns",
      "Financial instability and repeated losses",
      "Property disputes, family stress, and legal pressure",
      "Life direction and decision timing",
    ],
  },
};

export const servicesOfferedCopy = {
  hi: {
    title: "सेवाएँ (ऑनलाइन एवं ऑफलाइन)",
    sub: "प्रत्येक सेवा तर्क एवं साक्ष्य-आधारित पद्धति से।",
    items: [
      {
        title: "सम्पूर्ण कुंडली विश्लेषण",
        points: [
          "जन्म कुंडली की व्याख्या",
          "व्यक्तित्व मूल्यांकन",
          "शक्तियाँ, चुनौतियाँ एवं जीवन-मार्ग",
          "दशा-भुक्ति एवं गोचर विश्लेषण",
        ],
      },
      {
        title: "जन्म समय शुद्धीकरण",
        points: [
          "कस्पल इंटरलिंक थ्योरी से उच्च-सटीक सुधार",
          "जब जन्म समय अनिश्चित हो — अत्यंत उपयोगी",
          "भविष्यवाणी की सटीकता कई गुणा बढ़ जाती है",
        ],
      },
      {
        title: "विवाह एवं संबंध परामर्श",
        points: [
          "विवाह में विलंब का विश्लेषण",
          "मेलापक एवं अनुकूलता",
          "विवाहिक कलह / पृथकता में मार्गदर्शन",
          "विवाह-सम्बन्धी घटनाओं का समय",
        ],
      },
      {
        title: "संतान एवं प्रजनन परामर्श",
        points: [
          "संतान हेतु ग्रह-सहयोग",
          "अनुकूल समय का आकलन",
          "सहृदय एवं यथार्थ मार्गदर्शन",
        ],
      },
      {
        title: "करियर एवं आर्थिक ज्योतिष",
        points: [
          "नौकरी बनाम व्यवसाय निर्णय",
          "पदोन्नति एवं विकास काल",
          "विदेश अवसर",
          "वित्तीय स्थिरता विश्लेषण",
        ],
      },
      {
        title: "लाल किताब उपाय",
        points: [
          "सरल एवं व्यावहारिक उपाय",
          "नैतिक एवं सुरक्षित",
          "कोई महँगे अनुष्ठान नहीं, कोई भय नहीं",
        ],
      },
    ],
  },
  en: {
    title: "Services Offered (Online & Offline)",
    sub: "Every service is grounded in logic and evidence-based method.",
    items: [
      {
        title: "Complete Horoscope Analysis",
        points: [
          "Birth chart interpretation",
          "Personality assessment",
          "Strengths, challenges, and life path",
          "Dasha–Bhukti & transit analysis",
        ],
      },
      {
        title: "Birth Time Rectification",
        points: [
          "High-precision correction using Cuspal Interlink Theory",
          "Essential when birth time is uncertain",
          "Improves prediction accuracy significantly",
        ],
      },
      {
        title: "Marriage & Relationship Consultation",
        points: [
          "Marriage delay analysis",
          "Compatibility assessment",
          "Marital conflict & separation guidance",
          "Timing of marriage events",
        ],
      },
      {
        title: "Childbirth & Progeny Consultation",
        points: [
          "Planetary support for childbirth",
          "Favorable timing assessment",
          "Compassionate and realistic guidance",
        ],
      },
      {
        title: "Career & Financial Astrology",
        points: [
          "Job vs business decisions",
          "Promotion and growth periods",
          "Foreign opportunities",
          "Financial stability analysis",
        ],
      },
      {
        title: "Lal Kitab Remedies",
        points: [
          "Simple and practical remedies",
          "Ethical & non-harmful",
          "No costly rituals or fear-based solutions",
        ],
      },
    ],
  },
};

export const faqCopy = {
  hi: {
    title: "अक्सर पूछे जाने वाले प्रश्न",
    items: [
      {
        q: "आपका परामर्श अन्य ज्योतिषियों से भिन्न कैसे है?",
        a: "मेरा दृष्टिकोण विश्लेषणात्मक, तार्किक और समाधान-केन्द्रित है। मैं के.पी., कस्पल इंटरलिंक थ्योरी (CIL), लाल किताब एवं टैरो जैसी सत्यापित प्रणालियों पर आधारित रहता हूँ, न कि भय या अंधविश्वास पर। उद्देश्य यह है कि व्यक्ति समय, प्रवृत्तियाँ एवं विकल्प स्पष्ट रूप से समझ सके।",
      },
      {
        q: "क्या ज्योतिष भाग्य बदल सकता है?",
        a: "ज्योतिष भाग्य नहीं बदलता, न ही यह मुक्त इच्छा का स्थान लेता है। यह बताता है कि कब और क्यों कुछ अवस्थाएँ आती हैं, उनसे कैसे उत्तम प्रतिक्रिया दी जाए। यह स्पष्टता और तैयारी देता है, अनिवार्यता नहीं।",
      },
      {
        q: "क्या परामर्श गोपनीय है?",
        a: "हाँ। सभी परामर्श पूर्णतः गोपनीय हैं। व्यक्तिगत विवरण, कुंडली और चर्चाएँ कभी भी साझा नहीं की जातीं।",
      },
      {
        q: "परामर्श के लिए क्या जानकारी चाहिए?",
        a: "1) जन्म तिथि 2) जन्म समय 3) जन्म स्थान 4) चिंता / प्रश्न। यदि जन्म समय अनिश्चित हो, तो जन्म समय शुद्धीकरण किया जा सकता है।",
      },
      {
        q: "जन्म समय शुद्धीकरण क्या है और यह क्यों महत्वपूर्ण है?",
        a: "यह वह विधि है जिससे अज्ञात या संदिग्ध जन्म समय को सुधारा जाता है। कस्पल इंटरलिंक थ्योरी से यह प्रक्रिया कुंडली विश्लेषण एवं भविष्यवाणियों की सटीकता को अत्यधिक बढ़ा देती है।",
      },
      {
        q: "क्या ऑनलाइन परामर्श उपलब्ध हैं?",
        a: "हाँ। परामर्श ऑनलाइन (वीडियो/फोन) एवं ऑफलाइन (जयपुर में) दोनों उपलब्ध हैं। ऑनलाइन सत्र भी उसी गहराई और ध्यान से किए जाते हैं।",
      },
      {
        q: "क्या आप उपाय बताते हैं और क्या वे सुरक्षित होते हैं?",
        a: "हाँ। उपाय मुख्यतः लाल किताब पर आधारित हैं। ये सरल, नैतिक, सुरक्षित एवं व्यावहारिक होते हैं — किसी महँगे अनुष्ठान, रत्न या भय-आधारित पद्धति के बिना।",
      },
      {
        q: "क्या ज्योतिष विवाह एवं संबंधों में मदद कर सकता है?",
        a: "ज्योतिष समय-सम्बन्धी विषय, अनुकूलता एवं तनाव-अवधि की पहचान कर सकता है। यह स्पष्टता एवं मार्गदर्शन देता है, परन्तु व्यक्ति की इच्छा में हस्तक्षेप नहीं करता।",
      },
      {
        q: "क्या करियर एवं वित्त में मदद मिल सकती है?",
        a: "हाँ। अनुकूल अवधि, करियर दिशा, नौकरी परिवर्तन, व्यवसाय, पदोन्नति एवं वित्तीय स्थिरता को समझने में सहायता मिलती है।",
      },
      {
        q: "एक सत्र कितनी देर का होता है?",
        a: "सामान्यत: 30 से 60 मिनट, समस्या की जटिलता एवं आवश्यक सेवाओं के अनुसार।",
      },
      {
        q: "क्या परिणाम की गारंटी होती है?",
        a: "ज्योतिष ग्रह-समय एवं प्रवृत्तियों के आधार पर मार्गदर्शन देता है, गारंटी नहीं। परिणाम व्यक्ति के निर्णय, प्रयास एवं परिस्थितियों पर भी निर्भर हैं।",
      },
      {
        q: "किन्हें परामर्श से लाभ हो सकता है?",
        a: "कोई भी जो करियर, विवाह, वित्त, पारिवारिक विषयों या जीवन दिशा से जुड़ी अनिश्चितता में है, स्पष्ट एवं वस्तुनिष्ठ दृष्टिकोण प्राप्त कर सकता है।",
      },
      {
        q: "आपका कार्यालय कहाँ है?",
        a: "ऑफलाइन परामर्श जगतपुरा, जयपुर, राजस्थान में उपलब्ध हैं; ऑनलाइन परामर्श भारत एवं विदेश दोनों के लिए उपलब्ध हैं।",
      },
      {
        q: "नियुक्ति कैसे बुक की जाए?",
        a: "फ़ोन/व्हाट्सएप द्वारा या ईमेल पर आवश्यक विवरण भेजकर नियुक्ति बुक की जा सकती है। पूर्व नियुक्ति उचित समय सुनिश्चित करती है।",
      },
    ],
  },
  en: {
    title: "Frequently Asked Questions",
    items: [
      {
        q: "How is your astrology consultation different from others?",
        a: "My approach is analytical, logical, and problem-solving oriented. I rely on verified systems such as KP, Cuspal Interlink Theory (CIL), Lal Kitab and Tarot rather than fear-based or superstitious methods. The objective is to help people understand timing, tendencies and choices so they can make informed decisions.",
      },
      {
        q: "Do you believe astrology can change fate?",
        a: "Astrology does not change fate, nor does it replace free will. It helps explain when and why certain phases arise, what challenges may surface, and how best to respond. It provides clarity and preparedness, not inevitability.",
      },
      {
        q: "Is astrology consultation confidential?",
        a: "Yes. All consultations are strictly confidential. Personal details, charts, and discussions are never shared.",
      },
      {
        q: "What information is required for a consultation?",
        a: "1) Date of birth 2) Time of birth 3) Place of birth 4) Concern or question. If the birth time is uncertain, birth-time rectification can be performed.",
      },
      {
        q: "What is birth time rectification and why is it important?",
        a: "It is a method used to determine the correct birth time when it is unknown or doubtful. Using Cuspal Interlink Theory it significantly improves the accuracy of analysis and predictions.",
      },
      {
        q: "Do you provide online consultations?",
        a: "Yes. Consultations are available both online (video / phone) and offline (in Jaipur). Online sessions are conducted with the same depth and attention as in-person meetings.",
      },
      {
        q: "Do you offer remedies, and are they safe?",
        a: "Yes. Remedies are mainly based on Lal Kitab. They are simple, ethical, non-harmful and practical — no expensive rituals, gemstones, or fear-inducing practices.",
      },
      {
        q: "Can astrology help with marriage and relationships?",
        a: "Astrology can identify timing issues, compatibility factors and stress periods. It offers clarity and guidance but does not interfere with personal choice.",
      },
      {
        q: "Can astrology help with career and financial decisions?",
        a: "Yes. It helps you understand favourable periods, career direction, job changes, business prospects, promotions and financial stability — enabling better planning.",
      },
      {
        q: "How long does a consultation usually last?",
        a: "A consultation typically lasts 30 to 60 minutes, depending on complexity and the services required.",
      },
      {
        q: "Do you guarantee results in astrology?",
        a: "Astrology provides guidance based on planetary timing and tendencies, not guarantees. Outcomes also depend on choices, effort and circumstances.",
      },
      {
        q: "Who can benefit from a consultation?",
        a: "Anyone facing uncertainty in career, marriage, finance, family matters or life direction can benefit from a clear, objective astrological perspective.",
      },
      {
        q: "Where is your practice located?",
        a: "Offline consultations are held in Jagatpura, Jaipur, Rajasthan; online consultations are available for clients across India and abroad.",
      },
      {
        q: "How can I book an appointment?",
        a: "By calling or WhatsApp, or by sharing details on email. Prior appointment is advised to ensure adequate time.",
      },
    ],
  },
};

export const gallery = [
  // Note: astrodev.me hotlinks no longer resolve (that domain now serves this new
  // site). To bring back the gallery, upload photos to /app/frontend/public/gallery/
  // and reference them here as "/gallery/xyz.jpg".
];

export const sectionLabelsCopy = {
  hi: {
    zodiacTitle: "अपनी राशि चुनें",
    zodiacSub: "अपनी राशि पर क्लिक करके बुकिंग शुरू करें।",
    galleryTitle: "गैलरी",
    gallerySub: "पारंपरिक ज्योतिष एवं शोध की झलकियाँ।",
    momentTitle: "एक स्मरणीय क्षण",
    momentSub:
      "भारत के पूर्व मुख्य न्यायाधीश माननीय श्री न्यायमूर्ति डॉ. डी. वाई. चन्द्रचूड़ जी को उनका ही चित्र, अलंकृत फ्रेम में, सम्मान स्वरूप भेंट करते हुए।",
    momentQuote:
      "\"साक्ष्य पर आधारित निर्णय — चाहे न्यायालय हो या कुंडली — सत्य का द्वार खोलते हैं।\"",
    momentCredit:
      "माननीय श्री न्यायमूर्ति डॉ. डी. वाई. चन्द्रचूड़ जी के साथ — भारत के पूर्व मुख्य न्यायाधीश",
  },
  en: {
    zodiacTitle: "Choose Your Zodiac",
    zodiacSub: "Tap your rashi to begin a consultation.",
    galleryTitle: "Gallery",
    gallerySub: "Glimpses of traditional astrology and research.",
    momentTitle: "A Cherished Moment",
    momentSub:
      "Presenting Hon'ble Dr. Justice D. Y. Chandrachud, Former Chief Justice of India, with a framed portrait of himself as a mark of respect.",
    momentQuote:
      "\"Evidence-based judgement — in court or in the chart — opens the door to truth.\"",
    momentCredit:
      "With Hon'ble Dr. Justice D. Y. Chandrachud — Former Chief Justice of India",
  },
};
